<template>
  <div>
    <!-- middle box -->
    <div>
      <h2 class="text-lg font-medium text-gray-600 mb-3">BALANCES</h2>

      <div class="flex space-x-4">
        <div class="flex-1 bg-white rounded-lg p-4 flex items-center space-x-4 border border-gray-300">
          <div class="bg-white p-2 rounded-lg border">
            <component :is="Database" class="text-gray-500"/>
          </div>
          <div>
            <div class="text-base text-primary">Available</div>
            <div class="text-sm font-semibold text-gray-500">
              {{ account.currency }} {{ balances.available_balance }}
            </div>
          </div>
        </div>

        <div class="flex-1 bg-white rounded-lg p-4 flex items-center space-x-4 border border-gray-300">
          <div class="bg-white p-2 rounded-lg border">
            <component :is="Database" class="text-gray-500"/>
          </div>
          <div>
            <div class="text-base text-primary">Accounting</div>
            <div class="text-sm font-semibold text-gray-500">
              {{ account.currency }} {{ balances.accounting_balance }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="w-full mx-auto mt-8">
      <div class="flex justify-between items-center mb-3">
        <h2 class="text-lg font-medium text-gray-600">LAST MOVEMENTS</h2>
        <!--        <a class="text-orange-600 hover:underline flex items-center text-sm font-medium" href="#">-->
        <!--          <svg class="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24"-->
        <!--               xmlns="http://www.w3.org/2000/svg">-->
        <!--            <path d="M10 6l6 6-6 6" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>-->
        <!--          </svg>-->
        <!--          SEE MORE-->
        <!--        </a>-->
      </div>

      <div class="overflow-x-auto bg-white p-4 rounded-lg border border-gray-300">
        <table class="min-w-full divide-y divide-gray-200">
          <thead class="bg-white">
          <tr>
            <th class="px-4 py-2 text-left text-xs font-bold text-gray-900 uppercase tracking-wider">ID</th>
            <th class="px-4 py-2 text-left text-xs font-bold text-gray-900 uppercase tracking-wider">Oper. Date</th>
            <th class="px-4 py-2 text-left text-xs font-bold text-gray-900 uppercase tracking-wider">Type</th>
            <th class="px-4 py-2 text-left text-xs font-bold text-gray-900 uppercase tracking-wider">Doc. No.</th>
            <th class="px-4 py-2 text-left text-xs font-bold text-gray-900 uppercase tracking-wider">Description</th>
            <th class="px-4 py-2 text-right text-xs font-bold text-gray-900 uppercase tracking-wider">Value</th>
            <th class="px-4 py-2 text-right text-xs font-bold text-gray-900 uppercase tracking-wider">Status</th>
            <th v-if="user.user_type==='corporate'" class="px-2 py-2 text-right text-xs font-bold text-gray-900 uppercase tracking-wider">Stages</th>
            <th class="px-2 py-2 text-right text-xs font-bold text-gray-900 uppercase tracking-wider">Actions</th>
<!--            <th class="relative px-4 py-2"><span class="sr-only">Actions</span></th>-->
          </tr>
          </thead>

          <tbody class="bg-white divide-y divide-gray-200">
          <tr v-for="(item, idx) in movements" :key="idx"
              :class="[idx % 2 === 0 ? 'bg-white' : 'bg-gray-50','hover:bg-gray-100 transition-colors']">
            <td class="px-4 py-2 whitespace-nowrap text-sm text-gray-700">{{ item.id }}</td>
            <td class="px-4 py-2 whitespace-nowrap text-sm text-gray-700">{{ formatDate(item.oper_date) }}</td>
            <td class="px-4 py-2 whitespace-nowrap text-sm text-gray-700">
              {{ item.transaction_type === 'FX' ? 'Foreign Exchange' : item.transaction_type }}
            </td>
            <td class="px-4 py-2 whitespace-nowrap text-sm text-gray-700">
              <div class="flex items-center space-x-2">
                <span
                    class="cursor-pointer truncate"
                    @click="copyDocNo(item.doc_no)"
                    :title="item.doc_no">
                  {{ formatDocNo(item.doc_no) }}
                </span>
                <button
                    class="p-1 hover:text-gray-900 text-gray-400"
                    @click="copyDocNo(item.doc_no)"
                    title="Copy full doc no"
                    v-if="item.doc_no">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24"
                       stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round"
                          d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2"/>
                    <path stroke-linecap="round" stroke-linejoin="round"
                          d="M16 8h2a2 2 0 012 2v8a2 2 0 01-2 2h-8a2 2 0 01-2-2v-2"/>
                  </svg>
                </button>
              </div>
            </td>


            <td class="px-4 py-2 whitespace-nowrap text-sm text-gray-700">{{ item.description }}</td>
            <td
                :class="[
                        'px-4 py-2 whitespace-nowrap text-sm font-semibold text-right ',
                        item.transaction_type === TRANSACTION_TYPE.TYPE_CREDIT? 'text-green-600' :
                        (item.transaction_type === TRANSACTION_TYPE.TYPE_DEBIT || item.transaction_type?.includes('Transfer') || item.transaction_type?.includes('transfer'))
                         ? 'text-red-600': 'text-gray-600']">
              {{ formatNumber(item.value) }} {{item.currency}}
            </td>
            <td
                :class="[
                        'px-4 py-2 whitespace-nowrap text-sm font-semibold text-right ',
                        (item.status === TRANSACTION_STATUS.STATUS_APPROVED || item.status === TRANSACTION_STATUS.STATUS_COMPLETED || item.status === TRANSACTION_STATUS.STATUS_SETTLED) ? 'text-green-600':
                        item.status === TRANSACTION_STATUS.STATUS_REJECTED? 'text-red-600':
                        item.status === TRANSACTION_STATUS.STATUS_PENDING? 'text-yellow-500':
                        item.status === TRANSACTION_STATUS.STATUS_IN_REVIEW? 'text-yellow-600':
                        item.status === TRANSACTION_STATUS.STATUS_PROCESSING? 'text-yellow-700':
                        'text-gray-600']"
            >{{ item.status }}
            </td>

            <td v-if="user.user_type==='corporate'" class="px-4 py-2 whitespace-nowrap flex justify-center text-center text-gray-700">
              <component
                  v-if="(item.transaction_type===TRANSACTION_TYPE.TYPE_SEPA_TRANSFER || item.transaction_type===TRANSACTION_TYPE.TYPE_SWIFT_TRANSFER)"
                  :is="Workflow"
                  alt=""
                  class="w-5 h-5 mb-2 cursor-pointer justify-center align-middle"
                  @click="openStagesModal(item)"
              />
              <span v-else>-</span>
            </td>

            <td class="px-4 py-2 whitespace-nowrap text-sm text-gray-700">
              <component :is="FilePlus" alt="" class="w-5 h-5 mb-2 cursor-pointer"
                         @click="openModal(item)"/>
            </td>

          </tr>
          </tbody>
        </table>
      </div>

    </div>

    <!-- Modal -->
    <TransactionModal
        :isOpen="isModalOpen"
        :transaction="selectedTransaction"
        @close="isModalOpen = false"
    />

    <TransactionStagesModal
        v-if="selectedStagesTransaction"
        :show="isStagesModalOpen"
        :movement-id="selectedStagesTransaction.id"
        :movement-status="selectedStagesTransaction.status"
        :movement-type="selectedStagesTransaction.transaction_type"
        @close="closeTracking"
    />

  </div>
</template>

<script setup>
import {ref, watch, defineProps} from 'vue';
import TransactionModal from "@/components/view/TransactionModal.vue";
import api from '@/services/api';
import {Database, FilePlus, Workflow} from 'lucide-vue-next';
import {formatDate} from "@/utils/date";
import {formatNumber} from "@/utils/number";
import {TRANSACTION_STATUS, TRANSACTION_TYPE} from "@/constants/transactions";
import TransactionStagesModal from "@/components/view/TransactionStagesModal.vue";

const props = defineProps({
  account: {type: Object, required: true}
});

const balances = ref({available_balance: 0, accounting_balance: 0});
const movements = ref([]);
const isModalOpen = ref(false);
const selectedTransaction = ref({});

const selectedStagesTransaction = ref({});
const isStagesModalOpen = ref(false);

const user = ref({});

function openModal(transaction) {
  selectedTransaction.value = transaction;
  isModalOpen.value = true;
}

function openStagesModal(transaction) {
  selectedStagesTransaction.value = transaction;
  isStagesModalOpen.value = true;
}

const closeTracking = () => {
  isStagesModalOpen.value = false
  selectedStagesTransaction.value = null
}

const formatDocNo = (docNo) => {
  if (!docNo) return ''
  const len = docNo.length
  if (len <= 10) return docNo
  return `${docNo.slice(0, 4)}...${docNo.slice(-4)}`
}

const copyDocNo = (docNo) => {
  navigator.clipboard.writeText(docNo)
      .then(() => {
        console.log('Copied:', docNo)
        // میتونی Toast یا alert هم نمایش بدی
      })
      .catch(err => console.error('Failed to copy:', err))
}

const fetchAccountData = async (accountId) => {
  try {
    const res = await api.get(`/accounts/${accountId}/last-movements`, {headers: {Authorization: `Bearer ${localStorage.getItem('token')}`}});
    balances.value = res.data.balances;
    movements.value = res.data.movements;
    user.value = res.data.user;
    console.log(res);
  } catch (err) {
    console.error(err);
  }
};

watch(() => props.account, (newAccount) => {
  if (newAccount?.id) {
    fetchAccountData(newAccount.id);
  }
}, {immediate: true});

// onMounted(fetchAccountData)

</script>
